import React, { createContext, useContext, useState, useEffect } from 'react';

const AdminContext = createContext();

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdmin must be used within an AdminProvider');
  }
  return context;
};

export const AdminProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Check if admin is logged in on mount
  useEffect(() => {
    const adminToken = localStorage.getItem('adminToken');
    const adminExpiry = localStorage.getItem('adminExpiry');

    if (adminToken && adminExpiry) {
      const now = new Date().getTime();
      const expiry = parseInt(adminExpiry);

      if (now < expiry) {
        setIsLoggedIn(true);
      } else {
        // Token expired, clear it
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminExpiry');
      }
    }

    setIsLoading(false);
  }, []);

  const login = (username, password) => {
    // Simple credential check (in production, this would be API call)
    const validCredentials = username === 'admin' && password === 'admin123';

    if (validCredentials) {
      const token = 'admin-session-token';
      const expiry = new Date().getTime() + (24 * 60 * 60 * 1000); // 24 hours

      localStorage.setItem('adminToken', token);
      localStorage.setItem('adminExpiry', expiry.toString());

      setIsLoggedIn(true);
      return { success: true };
    }

    return { success: false, error: 'Invalid credentials' };
  };

  const logout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminExpiry');
    setIsLoggedIn(false);
  };

  const value = {
    isLoggedIn,
    isLoading,
    login,
    logout
  };

  return (
    <AdminContext.Provider value={value}>
      {children}
    </AdminContext.Provider>
  );
};
